import React, { ChangeEvent, InputHTMLAttributes, useEffect, useState } from "react";

import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Color } from "types/types";
import { colors } from "utils/constants";
import { HEX_COLOR_REGEX } from "utils/regex";
import timeout from "utils/timeout";
import { formatHexColor } from "utils/utils";
import "./ColorPicker.scss";

export type ColorPickerProps = Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> & {
  onValueChange: (e: ChangeEvent<HTMLInputElement> | DropdownChangeEvent) => void;
};

const ColorPicker: React.FC<ColorPickerProps> = props => {
  const { onValueChange, value: initValue, ...restProps } = props;
  const [colorText, setColorText] = useState(formatHexColor(initValue as string));

  useEffect(() => {
    setColorText(formatHexColor(initValue as string));
  }, [initValue]);

  const handleChange = (e: ChangeEvent<HTMLInputElement> | DropdownChangeEvent) => {
    let { value } = e.target;
    if (value.length > 0) value = formatHexColor(value);
    if ((!HEX_COLOR_REGEX.test(value) && value.length > 0) || value.length > 7) return;
    setColorText(value);

    timeout(() => {
      if (value.length === 7) onValueChange(e);
    }, 300);
  };

  const colorItemTemplate = (option: Color) => (
    <span style={{ border: `7px solid ${option.hex}` }}>{option.hex}</span>
  );

  return (
    <div className="color-picker p-inputgroup flex">
      <Dropdown
        value={colorText}
        onChange={handleChange}
        options={colors}
        optionLabel="hex"
        optionValue="hex"
        itemTemplate={colorItemTemplate}
        className="p-inputtext-sm align-items-center"
        onFocus={e => e.target.select()}
        id={restProps.id}
        editable
        name={restProps.name}
      />
      <input
        type="color"
        {...restProps}
        value={(colorText as string).length === 7 ? colorText : "#000000"}
        onChange={handleChange}
        className="p-inputgroup-addon"
      />
    </div>
  );
};

export default ColorPicker;
